import { AuthProvider } from "./AuthContext";
import { ContextProvider } from "./ExploreContext";
import { PremiumProvider } from "./PremiumContext";
import { ReferModalProvider } from "./ReferModalProvider";
import { FeedBackModelProvider } from "./FeedBackModelContext";

export const AppProviders = ({ children }) => (
  <AuthProvider>
    <PremiumProvider>
      <ContextProvider>
        <ReferModalProvider>
          <FeedBackModelProvider>{children}</FeedBackModelProvider>
        </ReferModalProvider>
      </ContextProvider>
    </PremiumProvider>
  </AuthProvider>
);
